/**
 This form groups together fields that are pre populated from a selected plot in an event
**/

import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { useForm } from 'react-final-form';
import { columnStyles } from 'styles';
import RichTextInput from 'ra-input-rich-text';
import { RichTextToolbar } from '../../../../src/utils/toolbarOptions';

const CustomLocationDescForm = forwardRef((props, ref) => {
  const formData = useForm();
  const form = columnStyles('column', '30vw');

  const changeLocationDescription = (locDesc) => {   
    formData.change('customLocationDescription', locDesc.description)
  }

  useImperativeHandle(ref, () => ({
    changeLocationDescription
  }));

  return (
    <>
      <RichTextInput
        label="Custom location description (leave blank or unchange to use default)"
        className={form.column}
        source="customLocationDescription"
        multiline
        toolbar={RichTextToolbar} 
      />
    </>
  )
});

export default CustomLocationDescForm;
